import React, { Component } from "react";

import { Drawer, Spin } from "antd";
import moment from "moment";
import { withRouter } from "react-router";
import { CLIENTS_LIST, SERVICES } from "../../../configs/constants";
import { pdcsApiUpsellProvider, requestApiUpsellProvider } from "../../../lib/api/providers";
import LastVisits from "./LastVisits.detailpdc";
import SourcesPdc from "./Sources.detailpdc";
import InfosPdc from "./Info.detailpdc";

import { get } from "../../../containers/activite/map/map.utils";
import { retailerLogos } from "../../../containers/activite/map/retailerLogos";

import Contact from "../../../components/contact/Contact.component";
import PdcMap from "./Map.detailpdc";
import AuthRender from "../../../containers/AuthRender";
import Request from "./Request.js/Request.detailpdc";

import { requests } from "../../../configs/constants";
import { HighlightedText, PlaceholderText } from "../Components/CustomSpan.component";
import EditDetailpdc from "./Edit.detailpdc";

const AWS_URL = "https://s3-eu-west-1.amazonaws.com/surveyefficiencecell/";

class DetailPdc extends Component {
  state = {
    pdc: null,
    isContactsVisible: false,
    request: null,
    isCreation: false
  };
  async componentDidMount() {
    const pdcId = this.props.pdcId;

    const request = get(["props", "location", "params", "request"], this, false);

    if (!request && (!pdcId || isNaN(pdcId))) {
      this.props.history.push("/basepdc/listpdcs");
      return;
    }

    if ((request && request.type !== requests.PDC_CREATION) || !request) {
      const responsePdc = await pdcsApiUpsellProvider.post(
        "/",
        { match: { pdc_id: parseInt(pdcId) } },
        {
          headers: {
            Authorization: this.props.token
          }
        }
      );
      if (!Array.isArray(responsePdc.data) || responsePdc.data.length !== 1) {
        alert("Point de contact non reconnu");
        this.props.history.push("/basepdc/listpdcs");
        return;
      }
      const pdc = responsePdc.data[0];

      await this.setState({ pdc });
    } else {
      this.setState({ pdc: request.data, isCreation: true });
    }
    await this.setState({ request });
  }

  render() {
    const { pdc, request } = this.state;
    const { token } = this.props;
    const typologie = get(["typology", "label"], pdc, "typologie non renseignée");
    const surface = get(["surface"], pdc, false);
    const contacts = get(["contacts"], pdc, {});
    const center = {
      lat: pdc && !isNaN(pdc.gps_lat) ? +pdc.gps_lat : null,
      lng: pdc && !isNaN(pdc.gps_long) ? +pdc.gps_long : null
    };
    const srcLogo = retailerLogos[pdc && pdc.retailer_id] ? `/img/retailer/${retailerLogos[pdc.retailer_id]}` : null;

    return (
      <AuthRender service={SERVICES.PDC}>
        <div style={{ width: "100%", marginRight: 30, marginBottom: 30 }}>
          {request && (
            <Request
              request={request}
              token={this.props.token}
              updatePdcCreation={pdc => this.setState({ pdc })}
              returnToList={() => this.props.history.push("/basepdc/listpdcs")}
            />
          )}
          <div style={{ width: "100%", display: "flex" }}>
            {pdc && (
              <div className="p-w-1-3" style={{ borderRadius: 10, marginRight: 20 }}>
                <PdcMap center={center} text={pdc.pdc_label} />
              </div>
            )}
            {pdc && (
              <div className="p-w-2-3 p-flex-col">
                <div className="p-flex p-pdc-detail-title">
                  <div className="p-w-1-2">
                    <div className="p-pdc-detail-name">
                      <HighlightedText request={request} field="pdc_label">
                        {pdc.pdc_label}
                      </HighlightedText>
                    </div>
                    <div style={{ display: "flex" }}>
                      {pdc.pdc_id ? <div className="p-pdc-detail-id">{pdc.pdc_id}</div> : <div></div>}
                      <div style={{ fontStyle: "italic", marginLeft: 30, verticalAlign: "center" }}>
                        Dernière màj le {moment(pdc.updated_at).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  </div>
                  <div className="p-w-1-2 p-pdc-detail-title-right p-flex p-al-full p-al-v-center">
                    <div className="p-pdc-detail-typologie p-flex">
                      {srcLogo && <img src={srcLogo} className="p-pdc-detail-typologie-logo" />}
                      <div className="p-pdc-detail-typologie-text p-al-c-center">
                        <span>
                          <HighlightedText request={request} field={"typology"}>
                            <span className="p-pdc-detail-typologie-title">{typologie}</span> -{" "}
                          </HighlightedText>
                          {surface ? (
                            <div>
                              <HighlightedText request={request} field="surface">
                                {surface} m<sup>2</sup>
                              </HighlightedText>
                            </div>
                          ) : (
                            <PlaceholderText text={"Surface non renseignée"} />
                          )}
                        </span>
                        <br />
                        <HighlightedText request={request} field="retailer_label">
                          {pdc.retailer_label || <PlaceholderText text={"Enseigne non renseignée"} />}
                        </HighlightedText>
                      </div>
                    </div>
                    <div className="p-btn p-btn-orange" onClick={() => this.setState({ isContactsVisible: true })}>
                      Contacts
                    </div>
                    <Drawer
                      title={"Contacts"}
                      placement="right"
                      closable={true}
                      onClose={() => this.setState({ isContactsVisible: false })}
                      getContainer={() => document.getElementById("root")}
                      visible={this.state.isContactsVisible}
                      width="400"
                    >
                      {Object.keys(contacts).length > 0
                        ? Object.entries(contacts).map(([clientId, contacts]) => {
                            const client = CLIENTS_LIST.find(client => client.idClient === parseInt(clientId));
                            const clientLabel = client ? client.label : "dossier inconnu";
                            if (!Array.isArray(contacts)) return null;
                            return (
                              <div key={clientId}>
                                <div style={{ marginBottom: 10 }}>{clientLabel}</div>
                                {contacts.map((contact, i) => (
                                  <Contact key={i + "-" + clientId} contact={contact} />
                                ))}
                              </div>
                            );
                          })
                        : "Aucun contact renseigné"}
                    </Drawer>
                  </div>
                </div>
                <div className="p-flex p-pdc-detail-infos">
                  <InfosPdc pdc={pdc} request={request} />
                  {!request && (
                    <EditDetailpdc
                      isRequest={false}
                      pdc={pdc}
                      onSubmit={async pdcModified => {
                        const data = {
                          pdc_id: pdc.pdc_id,
                          ...Object.keys(pdcModified).reduce((acc, curKey) => {
                            if (pdc[curKey] === pdcModified[curKey]) return acc;
                            return { ...acc, [curKey]: pdcModified[curKey] };
                          }, {})
                        };
                        try {
                          await requestApiUpsellProvider.post(
                            "/",
                            { type: requests.PDC_UPDATE, data },
                            {
                              headers: {
                                Authorization: this.props.token
                              }
                            }
                          );
                        } catch (e) {
                          console.log(e);
                        }
                      }}
                      token={token}
                    ></EditDetailpdc>
                  )}
                  <div className="p-w-1-2">
                    {pdc.photo_url ? (
                      <img className="p-pdc-detail-photo" src={`${AWS_URL}${pdc.photo_url}`} />
                    ) : (
                      <div
                        style={{
                          height: "100%",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "1px solid rgb(240, 240, 240)"
                        }}
                      >
                        <HighlightedText request={request} field="photo_url">
                          <PlaceholderText text={"Pas de photo pour ce pdc"} />
                        </HighlightedText>
                      </div>
                    )}
                  </div>
                </div>
                <div className="p-flex" style={{ minHeight: 100 }}>
                  <div className="p-w-1-2 p-pdc-detail-sources">
                    <SourcesPdc sources={pdc.sources} />
                  </div>
                  <div className="p-w-1-2 p-pdc-detail-last">
                    {!this.state.isCreation && <LastVisits token={this.props.token} pdcId={pdc.pdc_id} />}
                  </div>
                </div>
              </div>
            )}
            {!pdc && <Spin />}
          </div>
        </div>
      </AuthRender>
    );
  }
}

export default withRouter(DetailPdc);



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Detail.basepdc.js